import ArkLoader from '@src/js/common/ark-extensions';
import { LoadType } from '@tencent/ark-extensions';
import { BaseDriveSelectorPanel } from '../base';
import { ExtensionInstance, IDriveSelectorPanel } from '../type';

const componentConfig = {
    name: 'docs-component-drive-selector-panel-pc',
    loadType: LoadType.ON_DEMAND,
};

export class PcDriveSelectorPanel extends BaseDriveSelectorPanel {
    private static instance: IDriveSelectorPanel;

    public static getInstance() {
        if (!PcDriveSelectorPanel.instance) {
            PcDriveSelectorPanel.instance = new PcDriveSelectorPanel();
        }

        return PcDriveSelectorPanel.instance;
    }

    protected async loadExtensionInstance() {
        const arkService = ArkLoader.extensionService;
        await arkService.scanAndHandleExtensions([componentConfig]);
        const extensionInstance = await ArkLoader.extensionService.getExtension(componentConfig.name);

        return extensionInstance as ExtensionInstance;
    }
}
